import { Loader2, Inbox } from "lucide-react";

export const Spinner = ({ className = "py-24" }) => (
  <div className={`flex justify-center ${className}`} data-testid="loading-spinner">
    <Loader2 className="w-7 h-7 animate-spin text-gold" />
  </div>
);

export const Empty = ({ title, hint, action, testId = "empty-state" }) => (
  <div data-testid={testId} className="rounded-2xl border border-dashed border-gold/40 bg-sand/60 px-6 py-10 text-center">
    <Inbox className="mx-auto w-8 h-8 text-gold" />
    <p className="mt-3 font-display font-semibold text-navy">{title}</p>
    {hint && <p className="mt-1 text-sm text-ink-muted">{hint}</p>}
    {action && <div className="mt-4">{action}</div>}
  </div>
);

export const CardSkeleton = () => (
  <div className="rounded-2xl border border-line overflow-hidden animate-pulse">
    <div className="aspect-[4/3] bg-sand" />
    <div className="p-4 space-y-2">
      <div className="h-4 bg-sand rounded w-3/4" />
      <div className="h-3 bg-sand rounded w-1/2" />
    </div>
  </div>
);
